function parseCoordinate(value) {
    const coordinate = parseFloat(value)
    return Number.isFinite(coordinate) ? coordinate : null
}

function isValidCoordinate(coordinate) {
    return coordinate
        && Number.isFinite(coordinate.lat)
        && Number.isFinite(coordinate.lng)
}

function normalizeCoordinate(position) {
    if (!position) {
        return null
    }

    const lat = parseCoordinate(position.lat)
    const lng = parseCoordinate(position.lng)
    const coordinate = { lat, lng }

    return isValidCoordinate(coordinate) ? coordinate : null
}

export function getFeatureProperty(feature, propertyName) {
    if (!feature) {
        return null
    }

    if (typeof feature.getProperty === 'function') {
        return feature.getProperty(propertyName)
    }

    if (feature.properties) {
        return feature.properties[propertyName]
    }

    return feature.Fg ? feature.Fg[propertyName] : null
}

function getZipCenter(feature) {
    return normalizeCoordinate({
        lat: getFeatureProperty(feature, 'INTPTLAT10'),
        lng: getFeatureProperty(feature, 'INTPTLON10')
    })
}

export function collectMapBoundsCoordinates(locations, zipGeoJsons) {
    const markerCoordinates = (locations || [])
        .map(location => normalizeCoordinate(location.position))
        .filter(isValidCoordinate)

    const zipCoordinates = ((zipGeoJsons && zipGeoJsons.features) || [])
        .map(getZipCenter)
        .filter(isValidCoordinate)

    return [...markerCoordinates, ...zipCoordinates]
}
